var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"icon rounded",class:[
    ("icon_color_" + (_vm.icon && _vm.icon.color)),
    ("icon_size_" + _vm.size)
  ]},[_vm._v(" "+_vm._s(_vm.icon.mdi || "")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }